import { render } from "./scheduleLayout.vue?vue&type=template&id=374bed23"
import script from "./scheduleLayout.vue?vue&type=script&lang=js"
export * from "./scheduleLayout.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__